import React from 'react';

import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {formatSnils} from '../../../../../shared/pipes';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';
import {maskPrivateData, PrivateDataMaskType} from '../../../../../shared/pipes/maskPrivateData';
import {EvenOddListItemContentFactoryProps} from '../../../../../shared/components/evenOddList';

export const ProfileUserSnils = () => {
  const styles = useStyles(({theme}) => {
    return {
      prop: {
        textAlign: 'right',
        maxWidth: '65%',
        ...theme.fonts.body,
        color: theme.color.textColor,
        opacity: 1,
      },
      lbl: {
        ...theme.fonts.label,
      },
      label: {
        ...theme.fonts.body,
        color: theme.color.labelText,
        maxWidth: '38%',
      },
    };
  });

  const profile = useSelector(holderProfileSelector());

  if (!profile) {
    return null;
  }

  const documentsInfo = [
    profile?.snils
      ? {
          value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
            <>
              <Text testID='snils-label-id' style={styles.label}>
                СНИЛС
              </Text>
              <Text testID='snils-value-id' style={styles.prop}>
                {isMasked
                  ? maskPrivateData(formatSnils(profile.snils), {
                      maskType: PrivateDataMaskType.digits,
                    })
                  : formatSnils(profile.snils)}
              </Text>
            </>
          ),
        }
      : null,
  ].filter((item) => !!item);

  return <View snilsInfo={documentsInfo} />;
};
